export default "__VITE_ASSET__DFJNLkto__"